import TextInput from "components/common/custom/forms/BootTextField/TextField";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { GetAllSpeciality } from "../config/practitionerSliceAPi";
import { Controller } from "react-hook-form";
import MultiSelect from "components/common/MultiSelect";
import SearchPractitionerName from "./PractitionerSearch";
import { handlePractitonerFilter } from "../config/practitionerSlice";

const PractitionersListFilters = ({ watch, control, setValue }) => {
  const dispatch = useDispatch();
  const { specilaityList, practitionerFilters } = useSelector(
    (state) => state.practitioner
  );

  const { userData } = useSelector((state) => state.auth);
  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch"
  );

  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];

  useEffect(() => {
    if (specilaityList?.length === 0) {
      dispatch(GetAllSpeciality());
    }
  }, [specilaityList]);

  const handleBranch = (selected) => {
    if (!selected) {
      setValue("branch", null);
      dispatch(
        handlePractitonerFilter({
          check: "branch",
          value: null,
        })
      );
      return;
    }

    const value = {
      branch_name: selected.label,
      branch_id: selected.value,
    };
    setValue("branch", value);
    dispatch(handlePractitonerFilter({ check: "branch", value }));
  };
  const handleSpeciality = (selected) => {
    if (!selected) {
      setValue("speciality", null);
      dispatch(
        handlePractitonerFilter({
          check: "speciality",
          value: null,
        })
      );
      return;
    }

    const value = {
      specialities_name: selected.label,
      specialities_code: selected.value,
    };
    setValue("speciality", value);
    dispatch(handlePractitonerFilter({ check: "speciality", value }));
  };

  const handleLicenseNumber = (value) => {
    setValue("license_number", value);
    dispatch(
      handlePractitonerFilter({
        check: "license_number",
        value,
      })
    );
  };
  const handlePractitionerList = (value) => {
    setValue("name", value);
    dispatch(
      handlePractitonerFilter({
        check: "name",
        value,
      })
    );
  };
  const handleIDNumber = (value) => {
    setValue("id_number", value);
    dispatch(
      handlePractitonerFilter({
        check: "id_number",
        value,
      })
    );
  };

  useEffect(() => {
    setValue("branch", practitionerFilters?.branch);
    setValue("license_number", practitionerFilters?.license_number);
    setValue("national_id", practitionerFilters?.id_number);
    setValue("speciality", practitionerFilters?.speciality);
    setValue("name", practitionerFilters?.name);
  }, []);

  return (
    <Row alignItems="center">
      {Number(branchSetting?.list) === 1 && (
        <Col xs={12} sm={6} md={3} xl={2}>
          <label className="form-label">Branch</label>
          <Controller
            name="branch"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={allBranches?.map((item) => ({
                  value: item.branch_id,
                  label: item.branch_name,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                      value: field.value.branch_id,
                      label: field.value.branch_name,
                    }
                    : null
                }
                onChange={(selected) => handleBranch(selected)}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="name"
          label="Name"
          placeholder="Name"
          onChange={(value) => handlePractitionerList(value)}
          control={control}
          size="sm"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="license_number"
          label="License Number"
          placeholder="License Number"
          onChange={(value) => handleLicenseNumber(value)}
          control={control}
          size="sm"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label">Speciality</label>
        <Controller
          name="speciality"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={specilaityList?.map((item) => ({
                value: item.specialities_code,
                label: item.specialities_name,
              }))}
              isClearable={true}
              value={
                field.value
                  ? {
                    value: field.value.specialities_code,
                    label: field.value.specialities_name,
                  }
                  : null
              }
              onChange={(selected) => handleSpeciality(selected)}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="id_number"
          label="ID Number"
          placeholder="ID Number"
          onChange={(value) => handleIDNumber(value)}
          control={control}
          size="sm"
        />
      </Col>
    </Row>
  );
};

export default PractitionersListFilters;
